<template>
    <div style="height:100%">
        <slot v-if="!isMobile && browserSupported"></slot>
        <mobile-not-supported v-else-if="isMobile"></mobile-not-supported>
        <browser-not-supported v-else-if="!isMobile && !browserSupported"></browser-not-supported>
    </div>
</template>

<script>
  import BrowserSupportMixin from '../../../mixins/framework/browserSupport'
  import BrowserNotSupported from "../errors/BrowserNotSupported";
  import MobileNotSupported from "../errors/MobileNotSupported";

  export default {
    components: {BrowserNotSupported,MobileNotSupported},
    name: "platform-supported",
    mixins:[BrowserSupportMixin]
  }
</script>

<style scoped>

</style>
